module.exports = __webpack_public_path__ + "img/Costa Rica.9cd95e09.gif";